// extracted by mini-css-extract-plugin
export default {"login_singup_main_1":"LoginAndSignUp_login_singup_main_1__ec6Iq","login_singup_main_2":"LoginAndSignUp_login_singup_main_2__cK+rt"};